// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.casino-keyword-master {
  background-color: var(--ion-color-tertiary);
  position: relative;
}
.casino-keyword-master .casino-keyword-container {
  height: 3rem;
  z-index: 90;
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  padding-inline-start: 1rem;
  padding-right: 3rem;
}
.casino-keyword-master .casino-keyword-container .casino-keyword-item {
  height: 3rem;
  padding: 0 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}
.casino-keyword-master .casino-keyword-container .casino-keyword-item .cdn-icon-casino-keywords {
  --icon-height: 1rem;
  --icon-width: 1rem;
  padding: 0.5rem;
  filter: brightness(100);
}
.casino-keyword-master .casino-keyword-container .casino-keyword-item p {
  color: var(--ion-color-light);
  font-size: 0.875rem;
  letter-spacing: 0.8px;
  font-family: var(--font-med);
  margin: 0;
}
.casino-keyword-master .casino-keyword-container .casino-keyword-item-active {
  background-color: var(--ion-color-secondary);
  border-radius: 0.25rem;
  height: 2.5rem;
}
.casino-keyword-master .casino-keyword-container :last-child {
  margin-right: 90px;
}

.mobile-keywords-top-navbar-container {
  position: sticky;
  top: 70px;
  padding-top: 4px;
  z-index: 999 !important;
  width: 100%;
  background-color: var(--ion-color-tertiary);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
@media (orientation: landscape) and (min-width: 768px) {
  .mobile-keywords-top-navbar-container .safeArea {
    margin-left: calc(var(--sar, 0px) / 1.5);
    margin-right: calc(var(--sar, 0px) / 1.5);
  }
}
.mobile-keywords-top-navbar-container .mobile-top-navbar {
  background-color: var(--ion-color-tertiary);
  display: flex;
  overflow-x: auto;
  gap: 0.8rem;
}
.mobile-keywords-top-navbar-container .mobile-top-navbar::-webkit-scrollbar {
  display: none;
}
.mobile-keywords-top-navbar-container .mobile-top-navbar .mobile-keyword-top {
  border: 0.5px solid #A8A0B8;
  border-radius: 6px;
  display: flex;
  padding: 0.4rem;
  margin-top: 0.4rem;
  margin-bottom: 0.4rem;
}
.mobile-keywords-top-navbar-container .mobile-top-navbar .mobile-keyword-top:first-child {
  margin-left: 10px;
}
.mobile-keywords-top-navbar-container .mobile-top-navbar .mobile-keyword-top p {
  font-weight: 550;
  font-size: 14px;
  line-height: 12.88px;
  white-space: nowrap;
  color: #A8A0B8;
}
.mobile-keywords-top-navbar-container .mobile-top-navbar .navbar-keywords-isactive {
  background-color: #A8A0B8;
}
.mobile-keywords-top-navbar-container .mobile-top-navbar .navbar-keywords-isactive p {
  color: var(--ion-color-tertiary);
}

.searchbar-button {
  position: absolute;
  top: 0;
  left: unset;
  right: 0;
  z-index: 999;
  background-color: var(--ion-color-tertiary);
  height: 2.5rem;
  width: 8rem;
  border: 1.5px solid var(--searchbar-close);
  border-radius: 0.375rem;
  margin-right: 0.25rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.searchbar-button ion-icon {
  font-size: 1.25rem;
  color: var(--searchbar-close);
}
.searchbar-button p {
  color: var(--searchbar-close);
  font-size: 0.875rem;
  font-weight: 500;
}

@media screen and (max-width: 768px) {
  .searchbar-button {
    height: 3rem;
    width: 3rem;
  }
  .searchbar-button ion-icon {
    font-size: 1.5rem;
  }
  .searchbar-button p {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/lobby-categories/lobby-categories.component.scss"],"names":[],"mappings":"AAAA;EACE,2CAAA;EACA,kBAAA;AACF;AACE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,0BAAA;EACA,mBAAA;AAAJ;AAGI;EACE,YAAA;EACA,iBAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AAFN;AAIM;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EAEA,uBAAA;AAFR;AAKM;EACE,6BAAA;EACA,mBAAA;EACA,qBAAA;EACA,4BAAA;EACA,SAAA;AAHR;AAOI;EACE,4CAAA;EACA,sBAAA;EACA,cAAA;AALN;AAQI;EACE,kBAAA;AANN;;AAYA;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,2CAAA;EAEA,wCAAA;AAVF;AAaI;EADF;IAEI,wCAAA;IACA,yCAAA;EAVJ;AACF;AAaE;EACE,2CAAA;EAEA,aAAA;EACA,gBAAA;EACA,WAAA;AAZJ;AAcI;EACE,aAAA;AAZN;AAeI;EACE,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AAbN;AAeM;EACE,iBAAA;AAbR;AAgBM;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAdR;AAkBI;EACE,yBAAA;AAhBN;AAkBM;EACE,gCAAA;AAhBR;;AAuBA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EAEA,2CAAA;EACA,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uBAAA;EACA,qBAAA;EAEA,aAAA;EACA,6BAAA;EACA,mBAAA;AAtBF;AAwBE;EACE,kBAAA;EACA,6BAAA;AAtBJ;AAyBE;EACE,6BAAA;EACA,mBAAA;EACA,gBAAA;AAvBJ;;AA2BA;EACE;IACE,YAAA;IACA,WAAA;EAxBF;EA0BE;IACE,iBAAA;EAxBJ;EA2BE;IACE,aAAA;EAzBJ;AACF","sourcesContent":[".casino-keyword-master {\r\n  background-color: var(--ion-color-tertiary);\r\n  position: relative;\r\n\r\n  .casino-keyword-container {\r\n    height: 3rem;\r\n    z-index: 90;\r\n    overflow-x: auto;\r\n    white-space: nowrap;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 1rem;\r\n    padding-inline-start: 1rem;\r\n    padding-right: 3rem;\r\n\r\n\r\n    .casino-keyword-item {\r\n      height: 3rem;\r\n      padding: 0 .5rem;\r\n\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      flex-shrink: 0;\r\n\r\n      .cdn-icon-casino-keywords {\r\n        --icon-height: 1rem;\r\n        --icon-width: 1rem;\r\n        padding: .5rem;\r\n        -webkit-filter: brightness(10);\r\n        filter: brightness(100);\r\n      }\r\n\r\n      p {\r\n        color: var(--ion-color-light);\r\n        font-size: .875rem;\r\n        letter-spacing: 0.8px;\r\n        font-family: var(--font-med);\r\n        margin: 0;\r\n      }\r\n    }\r\n\r\n    .casino-keyword-item-active {\r\n      background-color: var(--ion-color-secondary);\r\n      border-radius: 0.25rem;\r\n      height: 2.5rem;\r\n    }\r\n\r\n    :last-child {\r\n      margin-right: 90px;\r\n    }\r\n\r\n  }\r\n}\r\n\r\n.mobile-keywords-top-navbar-container {\r\n  position: sticky;\r\n  top: 70px;\r\n  padding-top: 4px;\r\n  z-index: 999 !important;\r\n  width: 100%;\r\n  background-color: var(--ion-color-tertiary);\r\n  ;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n\r\n  .safeArea {\r\n    @media (orientation: landscape) and (min-width: 768px) {\r\n      margin-left: calc(var(--sar, 0px) / 1.5);\r\n      margin-right: calc(var(--sar, 0px) / 1.5);\r\n    }\r\n  }\r\n\r\n  .mobile-top-navbar {\r\n    background-color: var(--ion-color-tertiary);\r\n    ;\r\n    display: flex;\r\n    overflow-x: auto;\r\n    gap: 0.8rem;\r\n\r\n    &::-webkit-scrollbar {\r\n      display: none;\r\n    }\r\n\r\n    .mobile-keyword-top {\r\n      border: 0.5px solid #A8A0B8;\r\n      border-radius: 6px;\r\n      display: flex;\r\n      padding: 0.4rem;\r\n      margin-top: 0.4rem;\r\n      margin-bottom: 0.4rem;\r\n\r\n      &:first-child {\r\n        margin-left: 10px;\r\n      }\r\n\r\n      p {\r\n        font-weight: 550;\r\n        font-size: 14px;\r\n        line-height: 12.88px;\r\n        white-space: nowrap;\r\n        color: #A8A0B8;\r\n      }\r\n    }\r\n\r\n    .navbar-keywords-isactive {\r\n      background-color: #A8A0B8;\r\n\r\n      p {\r\n        color: var(--ion-color-tertiary);\r\n        ;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.searchbar-button {\r\n  position: absolute;\r\n  top: 0;\r\n  left: unset;\r\n  right: 0;\r\n  z-index: 999;\r\n\r\n  background-color: var(--ion-color-tertiary);\r\n  height: 2.5rem;\r\n  width: 8rem;\r\n  border: 1.5px solid var(--searchbar-close);\r\n  border-radius: 0.375rem;\r\n  margin-right: 0.25rem;\r\n\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n  align-items: center;\r\n\r\n  ion-icon {\r\n    font-size: 1.25rem;\r\n    color: var(--searchbar-close);\r\n  }\r\n\r\n  p {\r\n    color: var(--searchbar-close);\r\n    font-size: .875rem;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .searchbar-button {\r\n    height: 3rem;\r\n    width: 3rem;\r\n\r\n    ion-icon {\r\n      font-size: 1.5rem;\r\n    }\r\n\r\n    p {\r\n      display: none;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
